import { createAsyncThunk } from '@reduxjs/toolkit';
import { BundleProduct as BundleProductService } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchBundleProduct,
  FindBundleProduct,
  GetBundleProduct,
} from './interface';

export const findBundleProduct = createAsyncThunk(
  'bundleProduct/findBundleProduct',
  async (values: FindBundleProduct, { rejectWithValue }) => {
    try {
      const response = await BundleProductService.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createBundleProduct = createAsyncThunk(
  'bundleProduct/createBundleProduct',
  async (values: CreatePatchBundleProduct, { rejectWithValue }) => {
    try {
      const response = await BundleProductService.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchBundleProduct = createAsyncThunk(
  'bundleProduct/patchBundleProduct',
  async ({ id, ...values }: CreatePatchBundleProduct, { rejectWithValue }) => {
    try {
      const response = await BundleProductService.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getBundleProduct = createAsyncThunk(
  'bundleProduct/getBundleProduct',
  async ({ id }: GetBundleProduct, { rejectWithValue }) => {
    try {
      const response = await BundleProductService.get(id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
